import { MuiStylesType } from 'model/muiStyles.model';

export const muiStyles: MuiStylesType = {
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: 'calc(100vh - 90px)',
    overflow: 'hidden',
  },
};
